import { apiService } from "./../../app.service";

export const reportApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchReports: builder.query({
      query: () => ({
        url: "/user/report/pdf-history",
      }),
      providesTags: ["reports"],
    }),
    fetchReportsByPeriod: builder.mutation({
      query: (params) => ({
        url: "/user/report/pdf",
        method: "GET",
        params,
      }),
      invalidatesTags: ["reports"],
    }),
    deleteReport: builder.mutation({
      query: (logId) => ({
        url: `/user/report/pdf-history/${logId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["reports"],
    }),
  }),
});

export const {
  useFetchReportsByPeriodMutation,
  useFetchReportsQuery,
  useDeleteReportMutation,
} = reportApi;
